import { useState } from 'react';

import { useIsDesktop } from '~shared/lib/responsive';

import { Button } from '@breezeventures/ui-kit/button';
import { TextField } from '@breezeventures/ui-kit/text-field';

type Props = {
  link: string;
};

export const OrderLink = ({ link }: Props) => {
  const isDesktop = useIsDesktop();
  const canShare = !isDesktop && 'share' in navigator;
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setIsCopied(true);
    } catch {
      // clipboard may be unavailable or blocked by the browser
    }
  };

  const handleCopyBlur = () => {
    if (isCopied) {
      setTimeout(() => setIsCopied(false), 200);
    }
  };

  const handleShare = async () => {
    try {
      await navigator.share({ url: link });
    } catch {
      // user cancelled or share not supported
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <TextField
        label="Order link"
        labelPosition="inner"
        value={link}
        readOnly
        endSection={
          <Button
            type="button"
            variant={isCopied ? 'secondary' : 'primary'}
            size="s"
            disabled={isCopied}
            onClick={handleCopy}
            onBlur={handleCopyBlur}
            onMouseOut={handleCopyBlur}
          >
            {isCopied ? 'Copied' : 'Copy'}
          </Button>
        }
      />
      {canShare && (
        <Button
          type="button"
          variant="primary"
          size="l"
          width="full"
          onClick={handleShare}
        >
          Share link
        </Button>
      )}
    </div>
  );
};
